import { NextPage } from 'next';
import { Fragment, useState } from 'react';
// -------- custom component -------- //
import { Footer1 } from 'components/blocks/footer';
import { LocalSEO } from 'components/blocks/portfolio';
import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO';
import * as All from 'data/keywords';
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'Smooth Mover Removals',
  categories: 'seo, ppc',
  description:
    'Smooth Mover Removals is a local business that provides removal services. We were asked to design and develop a new website for them. We also conducted an SEO audit, which we passed on to Smooth Mover so they could make the easily explained changes themselves.',
  parentDirectories: 'seo-design-portfolio'
};

const Portfolio = All.LocalSEOArrays[7].keywords;
const contentRowClass = 'row gx-0';
const titleClass = 'display-6 mb-4';

const ProjectDetails: NextPage = () => {
  return (
    <Fragment>
      {/* <PageProgress /> */}

      <main className="content-wrapper">
        <SEO
          title={`${Portfolio[0].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
          urlENPT={``}
          url={`${Portfolio[0].url}/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
          // updated=""
          // published=""
          // modified=""
        />
        {/* ========== heading section ========== */}
        <section className="overflow-hidden position-relative blue">
          <div className="h-min-100vh h-md-auto color w-100"></div>
          <div className="container gx-0 text-center mt-n10 wrapper image-wrapper bg-image bg-overlay text-white overflow-hidden h-min-100vh h-md-auto d-flex align-items-center">
            <div className="h-100 w-100 hero-portfolio position-absolute left-0">
              <img
                className="w-100 object-fit-cover h-min-100vh h-md-auto w-min-100"
                src={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg.jpg`}
                // srcSet={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg@2x.jpg 2x`}
                alt={`${Portfolio[1].title}`}
              />
              <div></div>
            </div>
            <div className="row mx-auto">
              <div className="col-md-12 mx-auto text-center">
                <div className="post-header mx-auto text-center">
                  {/* <div className="post-category text-line text-white">Identity</div> */}

                  <h1 className="fs-15 text-uppercase text-white mb-3">- {Portfolio[0].title} -</h1>
                  <p className="display-4 text-capitalize">{details.pageName}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ========== details section ========== */}
        <section className="wrapper bg-light wrapper-border">
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15 pe-md-10">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                <h2 className={titleClass}>{Portfolio[0].title}</h2>

                <div className={`overflow-hidden ${contentRowClass}`}>
                  <div className="col-md-9 text-justify order-0 pe-10">
                    <h2 className="display-6 mb-4">{details.pageName}</h2>
                    <p>
                      <strong className="caption">{details.description}</strong>
                    </p>
                    <p>
                      SEOptimist  <NextLink title={All.HomeList[1].title} href="/" /> was approached by Smooth Mover Removals
                      to create a new WordPress website and provide affordable SEO services.
                    </p>
                    <p>
                      The team at SEOptimist designed and developed a new WordPress website for Smooth Mover Removals,
                      with a focus on user experience and search engine optimization. We implemented a clean and modern
                      design, easy navigation, and clear calls-to-action to improve conversion rates.
                    </p>
                    <p>
                      To ensure that the website was optimized for search engines, we conducted a comprehensive SEO
                      audit of the website. We identified areas for improvement, including optimizing meta titles and
                      descriptions, improving site speed, and implementing schema markup.
                    </p>
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/affordable-seo.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent' }}
                      className="mb-10 rounded-3 mw-30"
                    />
                    <h2>{Portfolio[1].title} </h2>
                    <p>
                      As part of the <NextLink title={All.HomeList[5].title} href="/" />, SEOptimist  provided a detailed
                      report to the client, outlining our recommendations for improving the website's search engine
                      rankings. We also provided guidance on how to implement the recommendations themselves, which
                      allowed the client to make the necessary changes at an affordable cost.
                    </p>
                    <p>
                      By implementing our recommendations, Smooth Mover Removals saw a significant improvement in their
                      search engine rankings, which led to an increase in traffic and enquiries. The affordable SEO
                      services we provided allowed the client to improve their online visibility without breaking the
                      bank.
                    </p>
                    <p>
                      At SEOptimist, we understand that not every business has the budget to invest in full SEO services,
                      which is why we offer affordable solutions that can be implemented by the client themselves. Our
                      team of experts can provide a comprehensive SEO audit and make recommendations that are easy to
                      understand and implement, so that you can improve your search engine rankings and increase your
                      online visibility. Contact us today to learn more about our affordable SEO services for London &
                      Brighton.
                    </p>{' '}
                    <p></p>
                    <NextLink title="Contact" href="/#contact" className="more hover" />
                  </div>

                  <div className="col-md-3 ms-auto order-1 pt-10">
                    <img
                      width={275}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent' }}
                      className="mb-10 rounded-top rounded-3"
                    />
                    <ul className="list-unstyled">
                      <li>
                        <h5 className="mb-1">Categories</h5>
                        <p>{details.categories}</p>
                      </li>

                      <li>
                        <h5 className="mb-1">Client Name</h5>
                        <p>{details.pageName}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <LocalSEO initialslide={0} />
          </div>
        </section>

        <ProjectDetailsNavigation />
      </main>
      <ContactFooterCombo location="london" />
    </Fragment>
  );
};

export default ProjectDetails;
